module.exports = __webpack_public_path__ + "img/20200609_130911.5381b404.jpg";